import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';

class WidgetOrdersOverTime {
  constructor(element, options) {
    this._element = element;
    this._options = options;
    this._cacheSelectors();
    this._init();
  }

  _cacheSelectors() {
    this._ordersOverTimeChart = document.getElementById('widgetOrdersOverTime');
  }

  _init() {
    const colorData1 = '#4a566b';
    const colorData2 = '#667894';

    this._chart = new Chart(this._ordersOverTimeChart, {
      type: 'line',
      options: {
        tension: 0.1,
        parsing: {
          xAxisKey: 'Date',
          yAxisKey: 'Count',
        },
        plugins: {
          legend: {
            labels: {
              color: colorData1,
            },
          },
        },
        scales: {
          x: {
            type: 'time',
            time: {
              unit: 'month',
              tooltipFormat: 'DD-MM-YYYY',
              displayFormats: {
                month: 'MMM yyyy',
              },
            },
            grid: {
              display: false,
            },
            ticks: {
              color: colorData1,
            },
          },
          y: {
            beginAtZero: true,
            display: false,
            ticks: {
              display: false,
            },
            grid: {
              display: false,
            },
          },
        },
      },
      data: {
        datasets: [
          {
            label: 'Orders',
            data: orders,
            borderColor: colorData1,
            pointRadius: 1,
            pointBackgroundColor: colorData1,
          },
          {
            label: 'Retour',
            data: orderReturns,
            borderColor: colorData2,
            pointRadius: 1,
            pointBackgroundColor: colorData2,
          },
        ],
      },
    });
  }
}

export default WidgetOrdersOverTime;
